/* Doit rester en premier : configure le chemin des chunks import() */
import "./public-path";

/* Main stylesheets, do not remove */
import "../scss/app.scss";
// import "../admin/scss/admin.scss";

/* Your own modules go here */
import options from "./lib/options";
import main from "./lib/main";
import navigation from "./lib/navigation";
import cookies from "./lib/cookies";
import contact from "./lib/contact";
import forms from "./lib/forms";
import blocks from "./lib/blocks";
import show from "./lib/show-on-scroll";
import menu from "./lib/menu";
import search from "./lib/search-form";
import gk_modal from "./lib/modal";
import searchModal from "./lib/search-modal";
import textHighlight from "./lib/text-highlight";
import openingHours from "./lib/opening-hours";
import tables from "./lib/tables";
import { initPageTransitions } from "./lib/page-transitions";
import { initReveal } from "./lib/reveal";

const initJs = () => {
  /*  if (wp_data.options.ga_enabled || wp_data.options.cookies_banner_enabled) {
        cookies.load();
    }*/
  options.load();
  navigation.load();
  main.load();
  forms.load();
  contact.load();
  blocks.load();
  show.load();
  menu.load();
  search.load();
  searchModal.load();
  gk_modal.load();
  textHighlight.load();
  openingHours.load();
  tables.load();

  if (window.gkData?.pageTransition) initPageTransitions(window.gkData.pageTransitionType);
  if (window.gkData?.revealEnable) initReveal();
};

initJs();
